import React, { useState, useEffect, useRef } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch

import { DraftButton } from "../../../../Components/Modal/supplier_app/DraftSelectionModel";
import DraftSelectionModal from "../../../../Components/Modal/supplier_app/DraftSelectionModel";

// import ConstantsList from '../../../common/Constants';

//Components
import Layout from "../../../../Layout/Layout";
import CreateSupplierMasterModal from "../../../../Components/Modal/supplier_app/CreateSupplierMasterModal";
import Constants from "../../../../common/SupplierConstants";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import { useNavigate } from "react-router-dom";
import {
  addPoDetailNumber,
  getServicePO,
} from "../../../../redux/feature/supplier_app/purchasingSlice";
import POCollabrationCommonFillter from "../../../../Components/Filter/POCollabration/POCollabrationCommonFillter";
import { currencyFormat } from "../../../../common/Validations";
import Moment from "react-moment";
import configFromEnv from "../../../../services/configuration";
import ShowStatus from "../../../../Components/Modal/supplier_app/Workflow/ShowStatus";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import POInvoiceUploadModal from "./POInvoiceUploadModal";
import ServicePoPrint from "./ServicePoPrint";
import { useReactToPrint } from "react-to-print";
import { MessageCircle } from "lucide-react";
import ChatBox from "../../../../Components/ChatBox/ChatBox";
import StickyColumn from "../../../../Components/Sticky/StickyColumn";
import CreatePOMasterModal from "../../../../Components/Modal/supplier_app/PO_Collabration/CreatePOMasterModal";
import ItemService from "../../../../services/supplier_appCommonService";
import { SearchField } from "../../../../Components/formElements/SearchField";

const ServicePurchaseOrderList = () => {
  // eslint-disable-next-line no-unused-vars
  const dispatch = useDispatch();
  const navigate = useNavigate();

  localStorage.setItem("menu", "Purchasing");
  localStorage.setItem("submenu", "Service Order");
  let purchase_orderData = useSelector(
    (state) => state?.purchasing?.purchase_order?.service_po?.data,
  ); // User Details from Store
  let config = useSelector((state) => state?.common?.data?.purchaseOrder); // config Details from Store
  let userData = useSelector((state) => state?.user); // User Details from Store
  let purchaseOrderTable = useSelector(
    (state) => state?.purchasing?.purchase_order?.service_po?.pagination,
  );

  // Format the price above to USD using the locale, style, and currency.
  // let USDollar = new Intl.NumberFormat("en-US", {
  //   style: "currency",
  //   currency: "USD",
  // });

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const [isCardVisible, setCardVisible] = useState(true);
  const [modalShow, setModalShow] = useState(false);

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");

  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const [getModalEditInvoice, setModalEditInvoice] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);
  const [viewInvoiceData, setViewInvoiceData] = useState(null);

  // Show Status Modal
  const [modalShowStatus, setModalShowStatus] = useState(false);
  const [sendDataModal, setSendDataModal] = useState("");
  const [modelTitle, setModelTitle] = useState("");
  const [getPurchaseDocType, setPurchaseDocType] = useState("");

  const [showDraftModal, setShowDraftModal] = useState(false);
  const openDraftModal = () => setShowDraftModal(true);
  // Cancel: navigate back
  const handleCancelDraftModal = () => {
    setShowDraftModal(false);
  };

  const [chatId, setChatId] = useState(null);

  const showUploadInvoice = async (purchasingDocumentNr) => {
    let obj = {
      purchasingDocumentNr,
    };
    setModalEditInvoice(true);
    setInvoiceData(obj);
    // Load any previously saved invoice data for this PO so it shows on reopen
    try {
      const res = await ItemService.getPurchaseOrderDetail({
        documentNumber: purchasingDocumentNr,
      });
      setViewInvoiceData(res?.data || null);
    } catch {
      setViewInvoiceData(null);
    }
  };
  const hideUploadInvoiceModal = () => {
    setModalEditInvoice(false);
    setViewInvoiceData(null);
  };

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Line Item Details");
    setItemLevelModalShow(true);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  const hideModal = () => {
    setModalShow(false);
  };

  const detailedPage = (poNumber) => {
    dispatch(addPoDetailNumber(poNumber));
    navigate(Constants.POCOLLABRATION_PURCHASE_ORDER_DETAIL_PAGE);
  };
  const fetchUsers = async (page) => {
    setLoading(true);
    // const response = await axios.get(`https://reqres.in/api/users?page=${page}&per_page=${perPage}&delay=1`);

    setData(purchase_orderData);
    // setTotalRows(purchase_orderData?.length);
    setLoading(false);
  };

  // const handlePageChange = (page) => {
  //   fetchUsers(page);
  // };

  // const handlePerRowsChange = async (newPerPage, page) => {
  //   setLoading(true);
  //   // const response = await axios.get(`https://reqres.in/api/users?page=${page}&per_page=${newPerPage}&delay=1`);

  //   setData(purchase_orderData);
  //   setPerPage(perPage);
  //   setLoading(false);
  // };

  useEffect(() => {
    fetchUsers(1); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [purchase_orderData]);
  const getMasterData = async () => {
    let obj = {
      codeType: "PurchaseDocType",
    };
    await ItemService.getMasterData(obj).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setPurchaseDocType(item?.data);
      } else {
        setPurchaseDocType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };

  const loadInitialPOData = () => {
    let obj = {
      module: "PO",
      queryName: "getServicePO",
      page: 1,
      per_page: 10,
    };

    dispatch(getServicePO(obj));
  };

  useEffect(() => {
    loadInitialPOData();
    getMasterData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageChange = (page) => {
    let obj = {
      module: "PO",
      queryName: "getServicePO",
      page: page,
      per_page: getNewPerPage,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getServicePO(obj));
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      module: "PO",
      queryName: "getServicePO",
      page: page,
      per_page: newPerPage,
      searchTerm: getCommonSearchTxt,
    };
    setNewPerPage(newPerPage);
    dispatch(getServicePO(obj));
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      module: "PO",
      queryName: "getServicePO",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getServicePO(obj));
  };
  /* Modal Function */
  const showStatusInfo = (rowData) => {
    setModalShowStatus(true);
    setSendDataModal(rowData);
    setModelTitle("Status Information");
  };

  const hideModalStatus = () => {
    setModalShowStatus(false);
  };

  const columns = [
    {
      name: "Collaboration",
      cell: (row) => (
        <>
          <span className="iconTable">
            <button
              onClick={() => toggleChat(row.vendorCode)}
              title="Chat With the User"
              // className={`text-sm ${chatId === row.userId ? "text-green-600" : "text-blue-600"} hover:text-blue-800`}
            >
              <MessageCircle className="w-5 h-5" />
            </button>
          </span>
          <span>
            <i className="bi bi-collection-play iconTable"></i>
          </span>
          <span>
            <i className="bi bi-stack iconTable"></i>
          </span>
        </>
      ),
      width: "150px",
    },
    {
      name: "Document Type",
      selector: (row) => row.purchasingDocumentCode,
      sortable: true,
      width: "220px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.purchasingDocumentType} </p>
        </div>
      ),
    },
    {
      name: "Purchase Type",
      selector: (row) => row.purchaseType || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.purchaseType} </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Document",
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPage(row.purchasingDocumentNr)}
        >
          {row.purchasingDocumentNr}{" "}
        </button>
      ),
      center: true,
      width: "150px",
    },
    // Conditionally include the 'workflowActionLogs' column
    ...(data?.some((row) => row.workflowActionLogs !== undefined)
      ? [
          {
            name: "Workflow log",
            selector: (row) => row.workflowActionLogs,
            cell: (row) => (
              <div
                style={{ width: "100%" }}
                className="d-flex justify-content-center iconTable"
              >
                <img
                  src="assets/img/newIcons/workflow.png"
                  alt="attachments"
                  style={{ width: "35px" }}
                  className="mt-1"
                  onClick={() => showStatusInfo(row.workflowActionLogs)}
                />
              </div>
            ),
            sortable: true,
            width: "132px",
          },
        ]
      : []),
    {
      name: "Line Items",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.items)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.items?.length} </span>
        </>
      ),
      width: "100px",
    },

    {
      name: "Upload INV",
      cell: (row) => (
        <>
          <button
            className="btnInfo"
            onClick={() => showUploadInvoice(row.purchasingDocumentNr)}
          >
            Upload
          </button>
        </>
      ),
      width: "120px",
    },

    {
      name: "Attachments",
      selector: (row) => row.attachments,
      cell: (row) => (
        <div
          style={{ width: "100%" }}
          className="d-flex justify-content-center cursor-pointer"
          onClick={() => handlePrintWithData(row)}
        >
          <img
            src="assets/img/newIcons/attached-file.png"
            alt="attachments"
            style={{ width: "25px" }}
            className="mt-1"
          />
        </div>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Version",
      selector: (row) => row.version || "--",
      sortable: true,
      center: true,
      width: "100px",
    },
    {
      name: "Status",
      cell: (row) => (
        <>
          <TableStatusField status={row.statusHeader} />
        </>
      ),
      center: true,
      width: "180px",
    },
    {
      name: "Date",
      selector: (row) => row.purchasingDocumentDate,
      sortable: true,
      width: "110px",
      style: {
        textAlign: "right",
      },
      center:true,
    },
    {
      name: "PO Value",
      cell: (row) => (
        <span className="numberFormate m-0 p-0 pt-1 fw-bold">
          {currencyFormat(Number(row.purchasingDocumentValue).toFixed(2))}
        </span>
      ),
      selector: (row) => row.purchasingDocumentValue || "--",
      sortable: true,
      center: true,
      width: "120px",
    },
    {
      name: "Currency ",
      cell: (row) => (
        <>
          <span className="m-0 p-0 pt-1 fw-bold">{row.currency}</span>
        </>
      ),
      selector: (row) => row.currency || "--",
      sortable: true,
      width: "110px",
    },
    {
      name: "Vendor",
      selector: (row) => row.vendorCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.vendorCode} </p>
          <p className="m-0 p-0">{row.vendorName} </p>
        </div>
      ),
    },
    // {
    //   name: "Payment Terms",
    //   cell: (row) => <>{row.paymentTerms}</>,
    //   selector: (row) => row.paymentTerms,
    //   sortable: true,
    //   width: "180px",
    // },
    // {
    //   name: "Inco Terms",
    //   selector: (row) => row.incoTerms,
    //   sortable: true,
    //   width: "180px",
    // },
    {
      name: "Payment Terms",
      selector: (row) => row.paymentTermsCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.paymentTerms} </p>
        </div>
      ),
    },
    {
      name: "Inco Terms",
      selector: (row) => row.incoTermsCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 ">{row.incoTerms} </p>
        </div>
      ),
    },
    // {
    //   name: "Payment Terms",
    //   selector: (row) => row.paymentTermsCode,
    //   sortable: true,
    //   width: "180px",
    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0 pt-1 fw-bold">{row.paymentTermsCode} </p>
    //       <p className="m-0 p-0">{row.paymentTerms} </p>
    //     </div>
    //   ),
    // },
    // {
    //   name: "Inco Terms",
    //   selector: (row) => row.incoTermsCode,
    //   sortable: true,
    //   width: "180px",
    //   cell: (row) => (
    //     <div>
    //       <p className="m-0 p-0 pt-1 fw-bold">{row.incoTermsCode} </p>
    //       <p className="m-0 p-0">{row.incoTerms} </p>
    //     </div>
    //   ),
    // },
    {
      name: "Created Date",
      selector: (row) => row.createdAt,
      cell: (row) => (
        <Moment format={configFromEnv.TIME_FORMATE_WITH_TIME}>
          {row.createdAt}
        </Moment>
      ),
      center: true,
      sortable: true,
      width: "160px",
    },
    {
      name: "Company",
      cell: (row) => (
        <>
          <span> {row.companyCodeCode} </span>
        </>
      ),
      center: true,
      width: "120px",
    },
    {
      name: "PR Number",
      selector: (row) => row.item?.requestNumber || "--",
      sortable: true,
      center: true,
      width: "150px",
    },
    {
      name: "RFQ",
      cell: (row) => (
        <button className="btnInfo">{row.rfxCollectiveNr || "--"} </button>
      ),
      center: true,
      width: "150px",
    },
    {
      name: "Quotation",
      cell: (row) => (
        <button className="btnInfo">{row.quotationNumber || "--"}</button>
      ),
      center: true,
      width: "150px",
    },
    {
      name: "Quotation Version",
      selector: (row) => row.rfqTechFocalPerson,
      sortable: true,
      center: true,
      width: "160px",
    },

    // {
    //   name: "Delivery Status",
    //   cell: (row) => (
    //     <>
    //       <button className="btnTable">{row.deliveredStatus}</button>
    //     </>
    //   ),
    //   width: "140px",
    // },
    // {
    //   name: "Invoice Status",
    //   cell: (row) => (
    //     <>
    //       <button className="btnTable">{row.invoicedStatus}</button>
    //     </>
    //   ),
    //   width: "140px",
    // },
    // {
    //   name: "Payment Status",
    //   cell: (row) => (
    //     <>
    //       <button className="btnTable">{row.paymentStatus}</button>
    //     </>
    //   ),
    //   width: "140px",
    // },
  ];

  const lineItemColInfo = [
    {
      name: "Item Nr",
      cell: (row) => <span>{row.purchasingDocumentItemNr} </span>,
      width: "180px",
    },
    // {
    //   name: "Schedule Nr",
    //   cell: (row) => <span>{row.purchasingDocumentItemNr} </span>,
    //   width: "180px",
    // },
    {
      name: "Material/Service",

      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode} </p>
          <p className="m-0 p-0">{row.materialDescription} </p>
        </div>
      ),
      width: "180px",
    },
    {
      name: "Material Group",
      cell: (row) => <span>{row.materialGroup} </span>,
      width: "220px",
    },
    {
      name: "Quantity",
      cell: (row) => <span>{row.purchaseQuantity} </span>,
      width: "220px",
    },
    {
      name: "Price Unit",
      cell: (row) => <span>{row.orderPriceUnit} </span>,
      width: "220px",
    },
    {
      name: "UOM",
      cell: (row) => <span>{row.orderUnitOfMeasure} </span>,
      width: "220px",
    },
    {
      name: "Net Value",
      cell: (row) => <span>{row.netValue} </span>,
      width: "220px",
    },
    {
      name: "Delivery Date",
      cell: (row) => <span>{row.deliveryDate} </span>,
      width: "220px",
    },
    {
      name: "Purchase Req.",
      cell: (row) => <span>{row.requestNumber} </span>,
      width: "220px",
    },
    {
      name: "Purchase Req. Item Nr",
      cell: (row) => <span>{row.prItemNr} </span>,
      width: "220px",
    },
    // {
    //   name: "Item Number",
    //   cell: (row) => <span>{row.purchasingDocumentItemNr} </span>,
    //   width: "180px",
    // },
    // {
    //   name: "Material",
    //   cell: (row) => <span>{row.materialCode} </span>,
    //   width: "180px",
    // },
    // {
    //   name: "Material Desc",
    //   cell: (row) => <span>{row.materialDescription} </span>,
    //   width: "220px",
    // },
    // {
    //   name: "Material Group",
    //   cell: (row) => <span>{row.materialGroup} </span>,
    //   width: "220px",
    // },
    // {
    //   name: "Quantity",
    //   cell: (row) => <span>{row.purchaseQuantity} </span>,
    //   width: "220px",
    // },
    // {
    //   name: "UOM",
    //   cell: (row) => <span>{row.orderUnitOfMeasure} </span>,
    //   width: "220px",
    // },
    // {
    //   name: "Delivery Date",
    //   cell: (row) => <span>{row.deliveryDate} </span>,
    //   width: "220px",
    // },
    // {
    //   name: "PR",
    //   cell: (row) => <span>{row.requestNumber || "-"} </span>,
    //   width: "220px",
    // },
    // {
    //   name: "PR Item",
    //   cell: (row) => <span>{row.prItemNr || "-"} </span>,
    //   width: "220px",
    // },
  ];

  const handleSuccessData = async (data) => {
    console.log(">> data", data);

    // Refresh the PO list after an update so the table reflects the change
    loadInitialPOData();
  };

  //service po print invocie
  const contentRef = useRef(null);
  const [getLoadingAdvice, setLoadingAdvice] = useState([]);
  // useReactToPrint declared at top level
  const handlePrint = useReactToPrint({
    contentRef,
    // documentTitle: `loadingAdvice_${getLoadingAdvice?.documentNumber || ""}`,
  });

  const handlePrintWithData = (row) => {
    setLoadingAdvice(row);

    // Wait for state updates before printing
    setTimeout(() => {
      handlePrint();
    }, 500);
  };

  //toggle chat

  const toggleChat = (groupId) => {
    // Toggle the same PR closes the chat
    if (chatId === groupId) {
      setChatId(null);
    } else {
      setChatId(groupId);
    }
  };
  /* Modal Function */
  const createRFQ = () => {
    setModalShow(true);
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">Service Purchase Order </h2>
                <p className="subText">
                  Lists of Service Purchase Order and details
                </p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
            </Row>
            <hr />

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">SR</span>
                    </Col>
                    <Col xs={12} md={6} lg={6}>
                      <span className="headerTitle">Service PO List</span>
                      <span className="subHeaderTitle">
                        View of Service PO and Status{" "}
                      </span>
                    </Col>

                    {/* <Col xs={4} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        onClick={() => {
                          alert("asd");
                        }}
                      >
                        <i className="bi bi-plus-lg"></i> Change Buyer
                      </button>
                    </Col> */}
                    <Col xs={12} md={2} lg={2} className="headerButtonAlign">
                      <Col xs={3} md={3} lg={3} className="">
                        <DraftButton
                          draftType={"MANUAL_PO"}
                          onClick={openDraftModal}
                        />
                      </Col>
                      {config?.createManualPOBtn &&
                        (userData?.data?.category === "VENDOR" ? (
                          ""
                        ) : (
                          <Col xs={3} md={3} lg={3} className="">
                            <button
                              className="btnTable"
                              onClick={() => createRFQ()}
                            >
                              <i className="bi bi-clipboard-check"></i> Manual
                              PO
                            </button>
                          </Col>
                        ))}
                      {/* <Col
                        xs={5}
                        md={5}
                        lg={5}
                        className="d-flex justify-content-end"
                      >
                        <button
                          className="btnTable"
                          onClick={() => createRFQ()}
                        >
                          <i className="bi bi-plus-lg"></i> Request Supplier for
                          ACK
                        </button>
                      </Col> */}
                      <Col
                        xs={5}
                        md={5}
                        lg={5}
                        className="d-flex justify-content-end"
                      >
                        <button
                          className="btnTable"
                          onClick={() => {
                            alert("asd");
                          }}
                        >
                          <i className="bi bi-x-circle"></i> Deletion
                        </button>
                      </Col>
                      <Col xs={2} md={1} lg={1}>
                        <POCollabrationCommonFillter />
                      </Col>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <StickyColumn
                        columnIndexes={[2, 5]}
                        leftOffsets={[0, 140]}
                      />
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={data}
                          progressPending={loading}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={purchaseOrderTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
        <div style={{ display: "none" }}>
          <ServicePoPrint ref={contentRef} data={getLoadingAdvice} />
        </div>
      </Row>

      <CreateSupplierMasterModal show={modalShow} onHide={() => hideModal()} />

      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      <ShowStatus
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />
      <CreatePOMasterModal
        show={modalShow}
        onHide={() => hideModal()}
        dropdowndata={getPurchaseDocType}
      />

      <POInvoiceUploadModal
        show={getModalEditInvoice}
        onHide={() => hideUploadInvoiceModal()}
        invoiceinfo={invoiceData}
        onsuccessdata={handleSuccessData}
        viewInvoiceData={viewInvoiceData}
      />

      <DraftSelectionModal
        show={showDraftModal}
        onHide={handleCancelDraftModal}
        draftType={"MANUAL_PO"}
        // toNavigate={Constants.SOURCING_PURCHASE_REQUISITION_CREATE}
        toNavigate={Constants.POCOLLABRATION_PURCHASE_ORDER_CREATION}
      />

      {chatId && (
        <ChatBox
          groupId={chatId}
          chatTitle="User"
          onClose={() => setChatId(null)}
        />
      )}
    </main>
  );
};

export default ServicePurchaseOrderList;
